import React from "react";
import { ShieldAlert } from "lucide-react";

export default function WellnessDisclaimer() {
    return (
        <section
            className="mt-20 mb-8 max-w-4xl mx-auto"
            aria-label="Avertissement sur la nature des soins"
            data-testid="wellness-disclaimer"
        >
            <div className="relative overflow-hidden rounded-3xl border border-border/60 bg-gradient-to-br from-muted/40 via-background to-secondary/5 p-8 md:p-10">
                <div className="absolute -top-16 -right-16 w-56 h-56 rounded-full bg-secondary/10 blur-3xl pointer-events-none" />
                <div className="relative flex flex-col md:flex-row gap-6">
                    <div className="flex-shrink-0">
                        <div className="w-12 h-12 rounded-2xl bg-secondary/15 flex items-center justify-center">
                            <ShieldAlert className="w-6 h-6 text-secondary" />
                        </div>
                    </div>
                    <div className="flex-1">
                        <p className="text-xs uppercase tracking-[0.3em] text-secondary font-medium mb-3">Avertissement</p>
                        <p className="text-sm md:text-[15px] leading-relaxed text-foreground/80">
                            Les soins énergétiques proposés sur ce site (séances individuelles et ateliers collectifs)
                            relèvent d'un <strong className="font-medium text-foreground/90">accompagnement de bien-être</strong> et ne constituent en aucun cas
                            un acte médical, un diagnostic, une prescription ou un traitement au sens de la loi.
                            Ils ne se substituent ni à une consultation médicale, ni à un suivi psychologique ou
                            psychiatrique, ni à un traitement prescrit par un professionnel de santé.
                        </p>
                        <p className="text-sm md:text-[15px] leading-relaxed text-foreground/80 mt-3">
                            En cas de problème de santé, il est recommandé de consulter un médecin ou un professionnel
                            de santé qualifié, et de <strong className="font-medium text-foreground/90">ne jamais interrompre un traitement médical en cours</strong> sans son avis.
                        </p>
                        <p className="text-sm md:text-[15px] leading-relaxed text-foreground/70 mt-3 italic">
                            Ces prestations ne garantissent aucun résultat thérapeutique ou curatif et ne dispensent
                            pas de recourir aux soins médicaux appropriés en cas d'urgence ou de pathologie avérée.
                        </p>
                    </div>
                </div>
            </div>
        </section>
    );
}
